export class batimentDetails {

    bad_id: string;
    bad_id_batiment: string;
    bad_com_vente_terrain: Number;
    bad_com_vente_construction: Number;
    bad_code_vente: string;
    bad_base_com_terrain: string;
    bad_base_com_construction: string;
    bad_tva_sur_com: Number;
    bad_date_update_prix: string;

    constructor(data?: any) {
        if (!data) {
            data = [];
        }

        this.bad_id                         = data['bad_id'] ? data['bad_id'] : null;
        this.bad_id_batiment                = data['bad_id_batiment'] ? data['bad_id_batiment'] : null;
        this.bad_com_vente_terrain          = data['bad_com_vente_terrain'] ? data['bad_com_vente_terrain'] : 0;
        this.bad_com_vente_construction     = data['bad_com_vente_construction'] ? data['bad_com_vente_construction'] : 0;
        this.bad_code_vente                 = data['bad_code_vente'] ? data['bad_code_vente'] : null;
        this.bad_base_com_terrain           = data['bad_base_com_terrain'] ? data['bad_base_com_terrain'] : null;
        this.bad_base_com_construction      = data['bad_base_com_construction'] ? data['bad_base_com_construction'] : null;
        this.bad_tva_sur_com                = data['bad_tva_sur_com'] ? data['bad_tva_sur_com'] : 17;
        this.bad_date_update_prix           = data['bad_date_update_prix'] ? data['bad_date_update_prix'] : null;
    }
}
